const state = {
  user: {name: '', id: '', roles: '',imageUrl: ''},
  org: {level: '',systemImage: '',systemName: '', orgName: ''},
  token: '',
  level: null,
  titleName: {name: ''},
  isEditMode: false,
  activeMenu: null,
  // 首页出货统计
  selledData: '',
  // 首页库存统计
  stockData: '',
  // 首页滴入数据
  mapData: '',
  openedInfoBoxId: '',
  // 国际化语言
  lang: localStorage.getItem('lang') || 'zh-cn',
  alarmNoticeType: localStorage.getItem('alarmNoticeType'),
  alarmConfig: '',
  orgCoord: '' || JSON.parse(localStorage.getItem('orgCoord'))
}
export default state